import React, { useState } from "react";
import { FaSync } from "react-icons/fa";

// A shared fallback for management modules that do not yet expose a dedicated
// data-loader callback. A hard reload guarantees each module requests fresh data.
const ModuleRefreshButton = ({ className = "", onRefresh }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const refresh = () => {
    setIsRefreshing(true);
    if (typeof onRefresh === "function") {
      Promise.resolve(onRefresh()).finally(() => setIsRefreshing(false));
      return;
    }
    window.location.reload();
  };
  return <button type="button" onClick={refresh} disabled={isRefreshing} className={`inline-flex items-center justify-center gap-2 rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 disabled:opacity-60 ${className}`}><FaSync className={isRefreshing ? "animate-spin" : ""} /> Refresh</button>;
};

export default ModuleRefreshButton;
